// extracted by mini-css-extract-plugin
export default {"base":"vp_oNhP4","bar":"vp_fX8L5","loaderAnimation":"vp_iio43","bkg":"vp_t9EW7"};